/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {ALLOW_MULTIPLE_PLATFORMS as ÉµALLOW_MULTIPLE_PLATFORMS} from './application_ref';
export {APP_ID_RANDOM_PROVIDER as ÉµAPP_ID_RANDOM_PROVIDER} from './application_tokens';
export {defaultIterableDiffers as ÉµdefaultIterableDiffers} from './change_detection/change_detection';
export {devModeEqual as ÉµdevModeEqual} from './change_detection/change_detection_util';
export {isListLikeIterable as ÉµisListLikeIterable} from './change_detection/change_detection_util';
export {ChangeDetectorStatus as ÉµChangeDetectorStatus, isDefaultChangeDetectionStrategy as ÉµisDefaultChangeDetectionStrategy} from './change_detection/constants';
export {Console as ÉµConsole} from './console';
export {inject as Éµinject, setCurrentInjector as ÉµsetCurrentInjector} from './di/injector';
export {APP_ROOT as ÉµAPP_ROOT} from './di/scope';
export {ComponentFactory as ÉµComponentFactory} from './linker/component_factory';
export {CodegenComponentFactoryResolver as ÉµCodegenComponentFactoryResolver} from './linker/component_factory_resolver';
export {ReflectionCapabilities as ÉµReflectionCapabilities} from './reflection/reflection_capabilities';
export {GetterFn as ÉµGetterFn, MethodFn as ÉµMethodFn, SetterFn as ÉµSetterFn} from './reflection/types';
export {DirectRenderer as ÉµDirectRenderer, RenderDebugInfo as ÉµRenderDebugInfo} from './render/api';
export {_sanitizeHtml as Éµ_sanitizeHtml} from './sanitization/html_sanitizer';
export {_sanitizeStyle as Éµ_sanitizeStyle} from './sanitization/style_sanitizer';
export {_sanitizeUrl as Éµ_sanitizeUrl} from './sanitization/url_sanitizer';
export {global as Éµglobal, looseIdentical as ÉµlooseIdentical, stringify as Éµstringify} from './util';
export {makeDecorator as ÉµmakeDecorator} from './util/decorators';
export {isObservable as ÉµisObservable, isPromise as ÉµisPromise} from './util/lang';
export {clearOverrides as ÉµclearOverrides, overrideComponentView as ÉµoverrideComponentView, overrideProvider as ÉµoverrideProvider} from './view/index';
export {NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR as ÉµNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR} from './view/provider';
